import { Button, Modal } from 'antd';
import { FunctionComponent } from 'react';

export type ModalConfirmBulletinCompletProps = {
    open: boolean,
    setOpen: React.Dispatch<React.SetStateAction<boolean>>,
    onConfirm: () => void,
}

export const ModalConfirmBulletinComplet: FunctionComponent<ModalConfirmBulletinCompletProps> = ({ open, setOpen, onConfirm }) => {

    const close = () => setOpen(false);

    return (<Modal title="Bulletin complet" open={open} width={450} onCancel={close}
        footer={<><Button onClick={close}>Annuler</Button><Button onClick={onConfirm} type="primary">Confirmer</Button></>} onOk={onConfirm}>
        <div>
            <p>Ce bulletin remplit toutes les conditions pour être considéré comme <strong>complet</strong>.</p>
            <p>En confirmant, un <strong>PDF va être généré</strong> et ce bulletin <strong>ne sera plus modifiable</strong>, sauf par un administrateur.</p>
            <p>Voulez-vous continuer ?</p>
        </div>
    </Modal>);

}
